import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, Input, ViewChild } from '@angular/core';
import { GrupoUsuarioComponent } from '../../grupo-usuario/grupo-usuario.component';
// import { FlujoTrabajoComponent } from '../../flujo-trabajo/flujo-trabajo.component';
// import { ContactoComponent } from '../../contacto/contacto.component';

@Component({
  selector: 'crear-grupo-usuarios-dialog',
  templateUrl: './crear-grupo-usuarios-dialog.component.html',
  styleUrls: ['./crear-grupo-usuarios-dialog.component.scss']
})
export class CrearGrupoUsuariosDialog {
  error: string = '';
  cargando: boolean = false;

  @ViewChild(GrupoUsuarioComponent) // accedemos al formulario
  private grupoForm: GrupoUsuarioComponent;

  // referencia a si mismo para poder cerrar el dialog...etc.
  constructor(
    public dialogCrear: MatDialogRef<CrearGrupoUsuariosDialog>
  ) { }

  onContactoInput() { // si cambian los datos ingresados
    this.error = ''; // limpiamos los mensajes de error del formulario
  }

  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  onCancelar(): void {
    this.dialogCrear.close();
  }

  onCrear(): void {
    this.error = '';
    try { // cacheo de errores
      this.dialogCrear.close(this.grupoForm.getGrupo());
    } catch (error) {
      this.error = error;
    }
  }
}